// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1lvT2","label":"Completed_label__ozV2u"};